module.exports = __webpack_public_path__ + "img/s_np_so.2e16bc3d.jpg";